import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const session_id = params.get("session_id");
    if (!session_id) {
      navigate("/", { replace: true });
      return;
    }
    api.post("/auth/session", { session_id })
      .then((r) => {
        setUser(r.data.user);
        const u = r.data.user;
        let dest = "/onboarding";
        if (u?.role === "buyer") dest = "/buyer/home";
        else if (u?.role === "seller" || u?.role === "both") dest = "/dashboard";
        else if (u?.is_admin) dest = "/admin";
        navigate(dest, { replace: true, state: { user: u } });
      })
      .catch(() => {
        navigate("/login", { replace: true });
      });
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="mono text-xs overline text-muted-foreground mb-4">Authenticating</div>
        <div className="w-12 h-12 border-2 border-foreground border-t-primary rounded-full animate-spin mx-auto" />
      </div>
    </div>
  );
}
